import type {
    Orientation} from "@@/shared/orientation";
import {
    orientations,
    orientationsMap,
} from "@@/shared/orientation";
import { toObjectMap } from "@@/utilities/dictionary";

const BOX_TEXT = "BOX_TEXT";
const CARD_LANDSCAPE = "CARD_LANDSCAPE";
const CARD_PORTRAIT = "CARD_PORTRAIT";
const CARD_SQUARE = "CARD_SQUARE";
const CARD_TEXT = "CARD_TEXT";
const ROW = "ROW";

type BOX_TEXT = typeof BOX_TEXT;
type CARD_LANDSCAPE = typeof CARD_LANDSCAPE;
type CARD_PORTRAIT = typeof CARD_PORTRAIT;
type CARD_SQUARE = typeof CARD_SQUARE;
type ROW = typeof ROW;
type CARD_TEXT = typeof CARD_TEXT;

const sectionItemDisplayTypes = [
    BOX_TEXT,
    CARD_LANDSCAPE,
    CARD_PORTRAIT,
    CARD_SQUARE,
    ROW,
    CARD_TEXT,
] as const;
type SectionItemDisplayType = typeof sectionItemDisplayTypes[number];
const sectionItemDisplayTypesMap = toObjectMap<SectionItemDisplayType>([
    ...sectionItemDisplayTypes,
]);

const getOriantationFromItemDisplayType = (
    displayType: SectionItemDisplayType,
    fallback: Orientation = orientationsMap.PORTRAIT
) =>
    orientations.find(
        _orientation => displayType.endsWith(_orientation) && _orientation
    ) || fallback;

export {
    sectionItemDisplayTypes,
    sectionItemDisplayTypesMap,
    BOX_TEXT,
    CARD_LANDSCAPE,
    CARD_PORTRAIT,
    CARD_SQUARE,
    ROW,
    CARD_TEXT,
    getOriantationFromItemDisplayType,
};
export type { SectionItemDisplayType };
